import { render, staticRenderFns } from "./SecurityRiskLevels.vue?vue&type=template&id=1b084947&scoped=true&"
import script from "./SecurityRiskLevels.vue?vue&type=script&lang=js&"
export * from "./SecurityRiskLevels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b084947",
  null
  
)

export default component.exports